import { AuthEffects } from './store/auth.effects';
import { authReducerFn } from './store/auth.reducers';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FooterLinksModule } from '../footer-links/footer-links.module';
import { SharedModule } from '../shared/shared.module';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginComponent } from './login/login.component';
import { ConfirmRegistrationComponent } from './registration/confirm-registration/confirm-registration.component';
import { RegistrationResendValidationComponent } from './registration/registration-resend-validation/registration-resend-validation.component';
import { RegistrationSuccessComponent } from './registration/registration-success/registeration-success.component';
import { RegistrationComponent } from './registration/registration.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { WelcomePageComponent } from './welcome-page/welcome-page.component';

@NgModule({
    declarations: [
        WelcomePageComponent,
        LoginComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        RegistrationComponent,
        ConfirmRegistrationComponent,
        RegistrationSuccessComponent,
        RegistrationResendValidationComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        FooterLinksModule,
        RouterModule,
        StoreModule.forFeature('authState', authReducerFn),
        EffectsModule.forFeature([AuthEffects])
    ]
})
export class AuthModule {

}
